import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    gap: theme.spacing(1.5),
    position: "absolute",
    top: "-0.375rem",
    left: "1rem",
    width: "100%",
    maxWidth: "calc(100% - 1rem)",
    paddingRight: theme.spacing(4),
    overflowX: "auto",
    backgrounColor: "red",
    scrollbarWidth: "none",
    WebkitOverflowScrolling: "touch",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  badge: {
    display: "inline-flex",
    width: "fit-content",
    flex: "0 0 auto",
    alignItems: "center",
    padding: theme.spacing(0.5, 2),
    borderRadius: "0.75rem",
    fontSize: "0.6875rem",
    fontWeight: 600,
    color: "white",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
    animation: "badge-fade-in 0.3s ease",

    "& span": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      maxWidth: "80px",
    },
  },
  images: {
    backgroundColor: "#242424",
  },
  public: {
    backgroundColor: "#7E4E90",
  },
  over18: {
    backgroundColor: theme.palette.secondary.main,
  },
  text: {
    backgroundColor: "#9c27b0",
  },
  image: {
    backgroundColor: "#25B7D3",
  },
  imageCircle: {
    width: "1.25rem",
    height: "1.25rem",
    borderRadius: "50%",
    overflow: "hidden",
    display: "inline-block",
    marginRight: theme.spacing(1),

    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
  },
  removeButton: {
    display: "grid",
    placeItems: "center",
    width: "1rem",
    height: "1rem",
    marginLeft: theme.spacing(1),
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    color: "white",
    border: "none",
    borderRadius: "50%",
    fontSize: "0.625rem",
    cursor: "pointer",
    transition: "background-color 0.2s",

    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  },
}));
